import defaultAttributes from '../defaultAttributes';

const CornerRightDown = [
  'svg',
  defaultAttributes,
  [
    ['polyline', { points: '10 15 15 20 20 15' }],
    ['path', { d: 'M4 4h7a4 4 0 014 4v12' }],
  ],
];

export default CornerRightDown;
